import { getObjType } from './utils'

const baseDatas = ['boolean', 'number', 'string']

export function isSameArr(arr1 = [], arr2 = []) {
  if (arr1.length !== arr2.length) {
    return false
  }
  let a
  a = arr1.every(arr => {
    return arr2.includes(arr)
  })
  return a
}

export function getDiffArray(from = [], to = []) {
  let arr = []
  if (from.length >= to.length) {
    arr = from
  } else {
    arr = to
  }
  let resultKey = ''
  for (let j = 0; j < arr.length; j++) {
    let vTo = to[j]
    let vFrom = from[j]
    let type = getObjType(vFrom)
    if (type === 'undefined') {
      resultKey = j.toString()
      break
    }
    if (baseDatas.includes(type)) {
      if (vTo !== vFrom) {
        resultKey = j
        break
      }
    } else if (type === 'array') {
      let ret = getDiffArray(vFrom, vTo)
      if (ret) {
        resultKey = j + '.' + ret
        break
      }
    } else if (type === 'object') {
      let retKey = getDiffField(vFrom, vTo)
      if (retKey) {
        resultKey = j + '.' + retKey
        break
      }
    }
  }
  return resultKey
}

/**
 * 获取两个对象字段值不一致的属性
 * （当前需求只需要查询一个）
 */
export function getDiffField(from = {}, to = {}) {
  let resultKey = ''

  let tos = Object.keys(to)
  let froms = Object.keys(from)
  let keys = []
  if (tos.length >= froms.length) {
    keys = tos
  } else {
    keys = froms
  }
  for (let i = 0; i < keys.length; i++) {
    let key = keys[i]
    let type = getObjType(to[key])
    let ft = getObjType(from[key])
    if (type === 'undefined' && ft !== 'undefined') {
      resultKey = key
      break
    }
    if (type === 'null' && from[key]) {
      resultKey = key
      break
    }
    if (type === 'array') {
      if (!from[key]) {
        from[key] = []
      }
      if (from[key].length !== to[key].length) {
        resultKey = key
        break
      }
      let ret = getDiffArray(from[key], to[key])
      if (ret !== '') {
        resultKey = key + '.' + ret
        break
      }
    } else if (baseDatas.includes(type)) {
      if (from[key] !== to[key]) {
        if (resultKey) {
          resultKey += '.'
        }
        resultKey += key
        break
      }
    } else if (type === 'object') {
      let ret = getDiffField(from[key], to[key])
      if (ret) {
        resultKey = key + '.' + ret
        break
      }
    }
  }

  return resultKey
}

export function getDiffValue(str = '', from = {}, to = {}) {
  let keys = str.split('.')
  let key = keys.shift()
  let oldValue = from[key],
    newValue = to[key]
  while (keys.length) {
    key = keys.shift()
    oldValue = oldValue && oldValue[key]
    newValue = newValue && newValue[key]
  }
  return {
    oldValue,
    newValue,
    key
  }
}

export function getDiffArrayIndex(str, from, to) {
  let keys = str.split('.')
  let key = keys.shift()
  let oldValue = from[key],
    newValue = to[key]
  while (keys.length) {
    if (!isNaN(Number(key))) {
      break
    }
    key = keys.shift()
    oldValue = oldValue[key]
    newValue = newValue[key]
  }
  return {
    oldValue,
    newValue,
    key
  }
}

/**
 * 比较内容是否相等
 */
export function diffContentEqual(source1, source2) {
  let t1 = getObjType(source1)
  let t2 = getObjType(source2)
  if (t1 !== t2) {
    return false
  }
  if (baseDatas.includes(t1)) {
    return source1 === source2
  }
  if (t1 === 'array') {
    return isSameArr(source2, source1)
  }

  if (t1 === 'object') {
    let res = getDiffField(source1, source2)
    return !res
  }
}
